module.exports = __webpack_public_path__ + "img/extensao-jpeg.5cbfc1ad.png";